import React, { lazy } from 'react';
import { CheckCircle2, Trophy } from 'lucide-react';
export function ProductPresentation() {
  return <section className="py-16 bg-[#FBF6EC]" data-id="element-188">
      <div className="max-w-5xl mx-auto px-4" data-id="element-189">
        <div className="text-center mb-12" data-id="element-190">
          <h2 className="text-4xl font-black text-rose-900 mb-4 flex items-center justify-center gap-3" data-id="element-191">
            📚 LENGUA PACK
          </h2>
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-6 py-2 rounded-full font-bold text-lg" data-id="element-192">
            <Trophy className="w-5 h-5" data-id="element-193" />
            El sistema N°1 para docentes de Lengua en Argentina
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-194">
          <div data-id="element-195">
            <h3 className="text-3xl font-bold text-stone-900 mb-6" data-id="element-196">
              MEGAPACK LENGUA LISTA
            </h3>
            <ul className="space-y-4 text-xl text-stone-700 mb-8" data-id="element-197">
              <li data-id="element-198">• 12 tomos organizados por grado y año.</li>
              <li data-id="element-199">• 180 actividades con secuencia completa.</li>
              <li data-id="element-200">• 6 bonus estratégicos.</li>
              <li className="font-bold text-rose-800" data-id="element-201">
                • Todo listo para usar desde hoy.
              </li>
            </ul>

            <div className="bg-white p-6 rounded-xl border border-stone-200 mb-8 font-mono text-lg space-y-2" data-id="element-202">
              <div className="flex justify-between items-center" data-id="element-203">
                <span className="tracking-widest font-bold text-rose-900" data-id="element-204">
                  1° 2° 3° 4° 5° 6°
                </span>
                <span className="text-stone-500" data-id="element-205">← PRIMARIA</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-206">
                <span className="tracking-widest font-bold text-emerald-800" data-id="element-207">
                  1° 2° 3° 4° 5° 6°
                </span>
                <span className="text-stone-500" data-id="element-208">← SECUNDARIA</span>
              </div>
            </div>

            <div className="space-y-3" data-id="element-209">
              <h4 className="font-bold text-xl text-stone-900 mb-4" data-id="element-210">
                12 TOMOS COMPLETOS
              </h4>
              {['Por grado y año', 'Con secuencia didáctica', 'Con evaluación incluida', 'Con 6 bonus estratégicos'].map((item, i) => <div key={i} className="flex items-center gap-3 text-lg font-medium text-stone-700" data-id="element-211">
                  <CheckCircle2 className="w-6 h-6 text-emerald-600" data-id="element-212" />
                  {item}
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-213">
            {/* TODO: replace with first uploaded image so user can swap easily */}
            <a href="#comprar" className="block cursor-pointer transform transition hover:scale-105" data-id="element-214">
              <img src="https://cdn.magicpatterns.com/uploads/c15xhKgrGPAEXqeuowRmPs/lengua_mock.png?w=640&q=72&auto=format" alt="Lengua Pack - Megapack Lengua 360 Primaria y Secundaria" loading="lazy" decoding="async" className="w-full drop-shadow-2xl" data-id="element-215" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}